var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FlotoFixedView',[_c('RequestServicePage',{attrs:{"back-link":_vm.$currentModule.getRoute('service-list', {
        params: Object.assign({}, (_vm.$route.params.searchTerm
            ? { searchTerm: _vm.$route.params.searchTerm }
            : {})),
      }),"created-link":function (id) { return _vm.$currentModule.getRoute('view-request', { params: { id: id } }); }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }